
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".8","y":".8","width":"62.4","height":"46.4","rx":".8","stroke":"currentColor","stroke-width":"1.6"}}),_c('circle',{attrs:{"cx":"57.101","cy":"5.1","r":"1.1","fill":"#9EA6B3"}}),_c('circle',{attrs:{"cx":"57.1","cy":"9.7","r":"1.1","fill":"#9EA6B3"}}),_c('circle',{attrs:{"cx":"57.1","cy":"14.3","r":"1.1","fill":"#9EA6B3"}}),_c('rect',{attrs:{"x":"5.601","y":"24.8","width":"52.8","height":"17.6","rx":".8","fill":"#E0E2E6"}}),_c('rect',{attrs:{"x":"5.601","y":"6.4","width":"26.4","height":"1.6","rx":".8","fill":"currentColor"}}),_c('rect',{attrs:{"x":"5.601","y":"11.2","width":"26.4","height":"5.6","rx":".8","fill":"#E0E2E6"}})])
          )
        }
      }
    